import { ReactNode } from 'react'
import InfoTooltip from '../../atoms/InfoTooltip'
import DashboardSearchInput from './DashboardSearchInput'
import ExportCsvButton from './ExportCsvButton'

type SearchProps = {
  id: string
  value: string
  onChange: (value: string) => void
  placeholder: string
  ariaLabel: string
  className?: string
}

type Props = {
  title: string
  tooltipText: string
  search: SearchProps
  onExport: () => Promise<void>
  exportDisabled?: boolean
  /** Slot to render extra header controls between title and search (rare). */
  extra?: ReactNode
}

const DashboardCardToolbar = ({ title, tooltipText, search, onExport, exportDisabled, extra }: Props): JSX.Element => (
  <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
    <div className="flex items-center gap-2">
      <h3 className="text-2xl font-bold text-dark-blue">{title}</h3>
      <InfoTooltip text={tooltipText} />
      {extra}
    </div>
    <div className="flex flex-wrap items-center gap-3">
      <DashboardSearchInput {...search} />
      <ExportCsvButton onExport={onExport} disabled={exportDisabled} />
    </div>
  </div>
)

export default DashboardCardToolbar
